<script setup lang="ts">
import { computed } from 'vue';
import { messageLines } from '@/errors';

/**
 * A toast's detail. A server message of several lines is a list of separate problems, such as every
 * error a data dictionary check found, so it is drawn as one.
 */
const props = defineProps<{ detail?: string }>();

const lines = computed(() => messageLines(props.detail));
</script>

<template>
  <ul v-if="lines.length > 1" class="p-toast-detail toast-detail-list">
    <li v-for="(line, index) in lines" :key="index">{{ line }}</li>
  </ul>
  <div v-else class="p-toast-detail">{{ detail }}</div>
</template>

<style scoped lang="scss">
.toast-detail-list {
  margin-bottom: 0;
  padding-left: 1.25rem;
  max-height: 50vh;
  overflow-y: auto;

  li + li {
    margin-top: 4px;
  }
}
</style>
